import { CmsObjectWithDefault } from '@components/Cms/types';

export type MagicLinkFormCmsKey = 'CheckYourEmail' | 'EmailSent' | 'ResendEmail';

export const MagicLinkFormCmsWithDefault: CmsObjectWithDefault<MagicLinkFormCmsKey> = {
    CheckYourEmail: {
        cmsId: 311090,
        defaultTranslation: 'Check your email',
    },
    EmailSent: {
        cmsId: 311091,
        defaultTranslation:
            'An email has been sent to {0}, containing a button for confirming your identity. Please open your email and click the button.',
    },
    ResendEmail: {
        cmsId: 206407,
        defaultTranslation: 'Resend email',
    },
};
